import { render, staticRenderFns } from "./ScratchCard.vue?vue&type=template&id=29b92913&scoped=true&"
import script from "./ScratchCard.vue?vue&type=script&lang=js&"
export * from "./ScratchCard.vue?vue&type=script&lang=js&"
import style0 from "./ScratchCard.vue?vue&type=style&index=0&id=29b92913&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b92913",
  null
  
)

export default component.exports